'use strict';

var setScrollHeight = require('../util/setScrollHeight');
var productTile = require('../product/productTileBadges');

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    var html = $updates.html();
    if (html) {
        $(selector).html(html);
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    var $mobileFilters = $('.filters-mobile');
    var $desktopFilters = $('.filters-desktop');
    $mobileFilters.addClass('filters-mobile--updating');
    $desktopFilters.addClass('filters-desktop--updating');
    var mobileExpandedRefinementId = $('.filters-mobile__refinement--expanded').attr('data-id');
    var desktopExpandedRefinementId = $('.filters-desktop__refinement--expanded').attr('data-id');
    updateDom($results, '.filters-mobile');
    updateDom($results, '.filters-desktop');
    setScrollHeight.init();
    $(`.filters-mobile__refinement[data-id="${mobileExpandedRefinementId}"]`).addClass('filters-mobile__refinement--expanded');
    $(`.filters-desktop__refinement[data-id="${desktopExpandedRefinementId}"]`).addClass('filters-desktop__refinement--expanded');
    setTimeout(() => {
        $mobileFilters.removeClass('filters-mobile--updating');
        $desktopFilters.removeClass('filters-desktop--updating');

    }, 600);
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.sorting',
        '.count',
        '.product-grid',
        '.show-more',
        '.filter-bar'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });

    $('body').trigger('search:filterUpdated');
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}


/**
 * function to update element's aria-expanded attribute
 *
 *  @param {string} $target - the jquery element that is the target of the change
 *  @param {string} toggler - element that will decide the toggle
 *  @return {undefined}
 */

function toggleAriaExpanded($target, toggler) {
    if (toggler === true) {
        return $target.attr('aria-expanded', false);
    }
    if (toggler === false) {
        return $target.attr('aria-expanded', true);
    }
}


/**
 * function to update element's tabindex attribute
 *
 *  @param {string} $target - the jquery element that is the target of the change
 *  @param {string} toggler - element that will decide the toggle
 *  @return {undefined}
 */
function toggleTabindex($target, toggler) {
    if (toggler === true) {
        $target.find(':button, :input').each(function () {
            if ($(this).hasClass('filters-desktop__refinement-toggle-cta') || $(this).hasClass('filters-desktop__selected-refinement-value-cta')) return;
            return $(this).attr('tabindex', -1);
        });
    } else {
        $target.find(':button, :input').each(function () {
            if ($(this).hasClass('filters-desktop__refinement-toggle-cta') || $(this).hasClass('filters-desktop__selected-refinement-value-cta')) return;
            return $(this).attr('tabindex', 0);
        });
    }
}

module.exports = {
    filter: function () {
        setScrollHeight.init();

        // Display refinements bar when Menu icon clicked
        $(document).on('click', 'button.filter-results', function () {
            $('.bbw-search-results__filters-mobile').show();
            $('.bbw-search-results__filters-mobile .close').focus();
            setScrollHeight.refresh();
            $('html').addClass('bbw-overflow-hidden--from-mobile-filters');
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $(document).on('click', '.filters-mobile__close-cta', function () {
            $('.bbw-search-results__filters-mobile').hide();
            $('.btn.filter-results').focus();
            $('.filters-mobile__refinement--expanded').removeClass('filters-mobile__refinement--expanded');
            $('html').removeClass('bbw-overflow-hidden--from-mobile-filters');
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $('.modal-background').hide();
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $(document).on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
            var url = this.value;
            var searchUrl = new URL(url);
            var searchParams = searchUrl.search;
            searchUrl = $(location).attr('origin') + $(location).attr('pathname') + searchParams;
            history.replaceState(searchUrl, document.title, searchUrl);
            $.spinner().start();
            $(this).trigger('search:sort', url);
            $.ajax({
                url: url,
                data: { selectedUrl: url },
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    productTile.manageTileBadges();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $(document).on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    $(document).trigger('search:showMoreUpdated', e);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $(document).on(
            'click',
            '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                var $this = $(this);
                var $refinementWrapper = $this.closest('.filters-desktop__refinement');
                var filterName = $this.find('.fragrance-ref__value-label').text();
                var url = $this.data('href');

                $.spinner().start();
                $this.trigger('search:filter', e);
                window.history.replaceState(null, null, url);

                $.ajax({
                    url: url,
                    data: {
                        isAjax: true,
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: $this.data('href')
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        var $lastSelectedFilter = $('.fragrance-ref__value-label:visible').filter(function () {
                            return $(this).text() == filterName;
                        });
                        $lastSelectedFilter.closest('button').focus();
                        $.spinner().stop();
                        //Accessibility fixes for tabindex and aria-expanded after ajax call for filters
                        toggleTabindex($refinementWrapper, false);
                        $('.filters-desktop__refinement-toggle-cta').each(function () {
                            toggleAriaExpanded($(this), !$(this).closest('.filters-desktop__refinement').hasClass('filters-desktop__refinement--expanded'));
                        });

                        $('.search-results').toggleClass('filters-applied', $('.filters-desktop__selected-refinements').length > 0);
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
    },

    showContentTab: function () {
        // Display content results from the search
        $(document).on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $(document).on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },

    toggleMobileRefinement() {
        $(document).on('click', '.filters-mobile__refinement-toggle-cta', function () {
            const $refinement = $(this).closest('.filters-mobile__refinement');
            const wasExpanded = $refinement.hasClass('filters-mobile__refinement--expanded');

            $('.filters-mobile__refinement--expanded').removeClass('filters-mobile__refinement--expanded');
            $refinement.toggleClass('filters-mobile__refinement--expanded', !wasExpanded);
        });
    },

    toggleDesktopRefinement() {
        $(document).on('click', '.filters-desktop__refinement-toggle-cta', function () {
            const $refinement = $(this).closest('.filters-desktop__refinement');
            const wasExpanded = $refinement.hasClass('filters-desktop__refinement--expanded');

            $('.filters-desktop__refinement--expanded').removeClass('filters-desktop__refinement--expanded');
            $refinement.toggleClass('filters-desktop__refinement--expanded', !wasExpanded);
            $(document).trigger('toggleDesktopRefinement', $refinement);
        });

        $(document).on('click', '.filters-desktop__close-cta', function () {
            $(this).closest('.filters-desktop__refinement--expanded').removeClass('filters-desktop__refinement--expanded');
            $(this).closest('.filters-desktop__refinement').find('.filters-desktop__refinement-toggle-cta').focus();
            $('.filters-desktop__refinement-toggle-cta').attr('aria-expanded', 'false');
        });

        $(document).on('click.outsideFilters', function (e) {
            var $target = $(e.target);
            var $refinementsWrapper = $target.closest('.filters-desktop');

            if (!$refinementsWrapper.length) {
                $(document).find('.filters-desktop__refinement--expanded').removeClass('filters-desktop__refinement--expanded');
                $(document).trigger('clickOutsideFilters');
                $('.filters-desktop__refinement-toggle-cta').attr('aria-expanded', 'false');
            }
        });

        // toggle tabindex & aria-expanded attr values if menu collapsed / expanded - keyboard navigation
        $(document).on('keydown click', '.filters-desktop__refinement-toggle-cta', function (event) {
            var $this = $(this);
            var $filterButton = $this;
            var $filterButtonContainer = $this.parent('.filters-desktop__refinement');
            var wasExpanded = $filterButtonContainer.hasClass('filters-desktop__refinement--expanded');

            if (event.which === 9 || event.key === 'Tab') {
                toggleTabindex($filterButtonContainer, !wasExpanded);
            }
            if (event.which === 13|| event.key === 'Enter') {
                $('.filters-desktop__refinement').find('button:not(.filters-desktop__refinement-toggle-cta, .filters-desktop__selected-refinement-value-cta), input').attr('tabindex', -1);
                $('.filters-desktop__refinement-toggle-cta').attr('aria-expanded', false);
                toggleAriaExpanded($filterButton, wasExpanded);
                toggleTabindex($filterButton, wasExpanded);
                toggleTabindex($filterButtonContainer, !wasExpanded);
            }
            if (event.which === 1) {
                $('.filters-desktop__refinement-toggle-cta').attr('aria-expanded', false);
                $this.attr('aria-expanded', wasExpanded);
            }
        });
    },

    filterFragrance() {
        $(document).on('input', '.fragrance-ref__filter-input', function (e) {
            $('.fragrance-ref__letter-item, .fragrance-ref__refinement-value').removeClass('d-none');

            if (!e.target.value) {
                return;
            }

            $('.fragrance-ref__refinement-value')
                .not(`[data-label*="${e.target.value.toLowerCase()}"]`)
                .addClass('d-none');

            $('.fragrance-ref__letter-item').each(function () {
                const $letterItem = $(this);
                const shouldHide = $letterItem.find('.fragrance-ref__refinement-value.d-none').length === $letterItem.find('.fragrance-ref__refinement-value').length;

                shouldHide && $letterItem.addClass('d-none');
            });
        });
    },

    cbtPLP() {
        // CBT Modification
        $('[data-cbt-plp]').each(function () {
            var $this = $(this);
            var cbtData = $this.data('cbt-plp');

            if (cbtData) {
                $this.on('click', function () {
                    window.dataLayer.push(cbtData);
                });
            }
        });
    }
};
